import React from 'react'
import { Link } from 'react-router-dom'
import {useTranslation} from "react-i18next";

export default function Settings() {

    const [t, i18n] = useTranslation('common');

    return (
        <div className="flex flex-row justify-center w-screen min-h-screen bg-bglight dark:bg-bgdark">
            <div className="p-8 border rounded-lg w-190 bg-itemlight dark:bg-itemdark border-borderlight dark:border-borderdark">
                <h2 className="text-2xl font-bold tracking-tight text-textlightfeature dark:text-textdarkfeature">{t('settingsTitle')}</h2>
                <div className="flex flex-col mt-12 mb-12 space-y-4">
                    <button onClick={() => i18n.changeLanguage('de')} className="px-3 py-1 border border-blue">de</button>
                    <button onClick={() => i18n.changeLanguage('en')} className="px-3 py-1 border border-blue">en</button>
                    <button onClick={() => i18n.changeLanguage('id')} className="px-3 py-1 border border-blue">id</button>
                </div>
                <Link to="/">Return to your feed</Link>
            </div>
        </div>
    )
}